// extracted by mini-css-extract-plugin
export default {"customSelect":"LangSelector_customSelect__t5J7o","centered":"LangSelector_centered__RECoO"};